<template>
  <v-layout row align-center pl-3 class="mt-0">
    <v-flex shrink>
      <div>{{dataTitle}}</div>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex shrink>
      <span v-if="isReload">
        <v-btn flat icon @click="reloadHandler">
          <v-icon>cached</v-icon>
        </v-btn>
      </span>
      <span v-if="isDownload">
        <v-btn flat icon @click="downloadHandler">
          <v-icon>get_app</v-icon>
        </v-btn>
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    dataTitle: {
      type: String
    },
    isReload: {
      type: Boolean,
      default: true
    },
    isDownload: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    reloadHandler() {
      this.$emit('reload:report')
    },
    downloadHandler() {
      this.$emit('download:report')
    }
  }
}
</script>
